<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>一键志愿填报</span>
		</div>
		<section class="gaokao-content">
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>1</p>
							<span>信息校对</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>2</p>
							<span>选择填报批次</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>3</p>
							<span>填写志愿表</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>4</p>
							<span>生成志愿表</span>
						</div>
					</div>
				</li>
			</ul>
			<article class="volunteer-one">
				<div class="one-li">
					<p>{{ condition.cityName }}</p>
					<p>{{ condition.subject }}</p>
					<p>{{ condition.branch }}分</p>
					<p>本科批</p>
				</div>
				<div class="one-btn">
					<p @click="goNextb()">重新填报批次</p>
					<p @click="goVltD()">生成志愿表</p>
				</div>
			</article>
			<article class="volunteer-list">
				<div class="volunteer-tab">
					<p :class="tabId == 1 ? 'on-nav' : ''" @click="tabBtn(1)">可冲击院校({{ TypeId1 }}所)</p>
					<p :class="tabId == 2 ? 'on-nav' : ''" @click="tabBtn(2)">较稳定院校({{ TypeId2 }}所)</p>
					<p :class="tabId == 3 ? 'on-nav' : ''" @click="tabBtn(3)">保底院校({{ TypeId3 }}所)</p>
				</div>
				<div class="major-list">
					<ul>
						<li v-for="(item, index) in list" :key="index">
							<div class="major-li01 lastIndex">
								<div class="major-li-btn">
									<p>{{ item.CollegesName }}</p>
								</div>
								<div class="major-li01-right float">
									<p>
										<span>院校代码:</span>
										<span>{{ item.CollegesCode }}</span>
										<span v-if="tabId == 1" class="li-icon">可冲击</span>
										<span v-if="tabId == 2" class="li-icon">较稳定</span>
										<span v-if="tabId == 3" class="li-icon">保底</span>
									</p>
									<el-select v-model="item.Voluntarily" placeholder="请选择" @change="volunteerdSel(index)">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</div>
							</div>
							<div class="major-li01 widthx">
								<div class="major-li01-right">
									<p>
										<span>招生地区:</span>
										<span>{{ item.EnrollmentArea }}</span>
									</p>
									<p>
										<span>考生类别:</span>
										<span>{{ item.CandidatesType }}</span>
									</p>
									<p>
										<span>平均分:</span>
										<span>{{ item.Average }}</span>
									</p>
									<p>
										<span>最低分:</span>
										<span>{{ item.LowestScore }}</span>
									</p>
									<p>
										<span>最低位次:</span>
										<span>{{ item.LowestOrder }}</span>
									</p>
								</div>
							</div>
							<div class="major-li02">
								<p class="major-txt01">备注:</p>
								<p class="major-txt04">{{ item.Remarks }}</p>
							</div>
						</li>
					</ul>
					<div class="flex xend major-page" style="margin: 20px auto;">
						<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
					</div>
				</div>
			</article>
		</section>

		<!-- 我的志愿表 -->
		<section class="volunteer-frome">
			<div class="from-img" @click="majorBtn"><img src="../../../image/vol-my.png" /></div>
			<article class="from-pop animated fadeIn" v-show="isPop">
				<div class="from-tit">
					<span>我的志愿</span>
					<img @click="majorBtn()" src="../../../image/vol-del-t.png" />
				</div>
				<div class="from-pList">
					<div class="plist-ul" v-for="(item, index) in vltList" :key="index">
						<div class="ul-title">
							<p class="ul-tleft">{{ item.Text }}</p>
							<div class="ul-tright" v-if="item.CollegesId > 0">
								<div class="ul-right-c01">
									<p>{{ item.CollegesName }}</p>
									<p>{{ item.EnrollmentArea }}</p>
									<span>{{ item.CollegesType == 1 ? '可冲击' : item.CollegesType == 2 ? '较稳定' : '保底' }}</span>
								</div>
								<p class="ul-right-btn" @click="editMajor(item.CollegesName, index)">编辑专业</p>
								<p class="ul-right-btn" @click="delMajorAll(index)">清空</p>
							</div>
							<div class="add-school" v-else @click="addschool">
								<img src="../../../image/add-a.png" />
								<p>添加院校</p>
							</div>
						</div>
						<ul class="list-li" v-if="item.CollegesId > 0">
							<li v-for="(t, index2) in item.MajorList" :key="index2">
								<span>{{ t.Name }}</span>
								<img src="../../../image/vol-del.png" @click="deltMajr(index, index2)" />
							</li>
						</ul>
					</div>

					<div class="one-btn"><p @click="goVltD()">生成志愿表</p></div>
				</div>
			</article>
		</section>
		<!-- 选择专业弹窗 -->
		<div class="popup" v-show="majorSel">
			<div class="major-pop animated fadeIn">
				<div class="major-ptit">
					<p>
						<font color="#333">{{ obj.CollegesName }}</font>
						—{{ obj.Year }}年录取情况
					</p>
					<img src="../../../image/vol-del-t.png" @click="majorPop()" />
				</div>
				<div class="major-ptable">
					<table class="major-tab" cellpadding="0" cellspacing="0" align="center" rules="none">
						<tr>
							<th>专业名称</th>
							<th>专业分</th>
							<th>操作</th>
						</tr>
						<tr v-for="(item, index) in majorTab" :key="index">
							<td>{{ item.MajorName }}</td>
							<td>{{ item.LowestScore }}</td>
							<td v-if="item.Number > 0">
								<span v-if="item.Number == 1" @click="dleMj(index)" class="on-span">取消第一专业</span>
								<span v-if="item.Number == 2" @click="dleMj(index)" class="on-span">取消第二专业</span>
								<span v-if="item.Number == 3" @click="dleMj(index)" class="on-span">取消第三专业</span>
								<span v-if="item.Number == 4" @click="dleMj(index)" class="on-span">取消第四专业</span>
								<span v-if="item.Number == 5" @click="dleMj(index)" class="on-span">取消第五专业</span>
								<span v-if="item.Number == 6" @click="dleMj(index)" class="on-span">取消第六专业</span>
							</td>
							<td v-else>
								<span v-if="Current == 0" @click="sleMj(index)">作为第一专业</span>
								<span v-if="Current == 1" @click="sleMj(index)">作为第二专业</span>
								<span v-if="Current == 2" @click="sleMj(index)">作为第三专业</span>
								<span v-if="Current == 3" @click="sleMj(index)">作为第四专业</span>
								<span v-if="Current == 4" @click="sleMj(index)">作为第五专业</span>
								<span v-if="Current == 5" @click="sleMj(index)">作为第六专业</span>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
	data() {
		return {
			tabId: 1,
			Current: 0,
			ZYixt: 0,
			// 列表
			list: [],
			options: [
				{ value: 0, label: '请选择' },
				{ value: 1, label: '第一志愿' },
				{ value: 2, label: '第二志愿' },
				{ value: 3, label: '第三志愿' },
				{ value: 4, label: '第四志愿' },
				{ value: 5, label: '第五志愿' },
				{ value: 6, label: '第六志愿' },
				{ value: 7, label: '第七志愿' },
				{ value: 8, label: '第八志愿' },
				{ value: 9, label: '第九志愿' },
				{ value: 10, label: '第十志愿' },
				{ value: 11, label: '第十一志愿' },
				{ value: 12, label: '第十二志愿' },
				{ value: 13, label: '第十三志愿' },
				{ value: 14, label: '第十四志愿' },
				{ value: 15, label: '第十五志愿' },
				{ value: 16, label: '第十六志愿' },
				{ value: 17, label: '第十七志愿' },
				{ value: 18, label: '第十八志愿' },
				{ value: 19, label: '第十九志愿' },
				{ value: 20, label: '第二十志愿' },
				{ value: 21, label: '第二十一志愿' },
				{ value: 22, label: '第二十二志愿' },
				{ value: 23, label: '第二十三志愿' },
				{ value: 24, label: '第二十四志愿' },
				{ value: 25, label: '第二十五志愿' },
				{ value: 26, label: '第二十六志愿' },
				{ value: 27, label: '第二十七志愿' },
				{ value: 28, label: '第二十八志愿' },
				{ value: 29, label: '第二十九志愿' },
				{ value: 30, label: '第三十志愿' },
				{ value: 31, label: '第三十一志愿' },
				{ value: 32, label: '第三十二志愿' },
				{ value: 33, label: '第三十三志愿' },
				{ value: 34, label: '第三十四志愿' },
				{ value: 35, label: '第三十五志愿' },
				{ value: 36, label: '第三十六志愿' },
				{ value: 37, label: '第三十七志愿' },
				{ value: 38, label: '第三十八志愿' },
				{ value: 39, label: '第三十九志愿' },
				{ value: 40, label: '第四十志愿' },
				{ value: 41, label: '第四十一志愿' },
				{ value: 42, label: '第四十二志愿' },
				{ value: 43, label: '第四十三志愿' },
				{ value: 44, label: '第四十四志愿' },
				{ value: 45, label: '第四十五志愿' },
				{ value: 46, label: '第四十六志愿' },
				{ value: 47, label: '第四十七志愿' },
				{ value: 48, label: '第四十八志愿' },
				{ value: 49, label: '第四十九志愿' },
				{ value: 50, label: '第五十志愿' }
			],
			value: '',
			// 志愿表
			vltList: [
				{
					Text: '第一志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第五志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第六志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第七志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第八志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第九志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十一志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十二志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十三志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十四志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十五志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十六志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十七志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十八志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第十九志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十一志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十二志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十三志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十四志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十五志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十六志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十七志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十八志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第二十九志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十一志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十二志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十三志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十四志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十五志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十六志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十七志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十八志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第三十九志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十一志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十二志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十三志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十四志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十五志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十六志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十七志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十八志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第四十九志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				},
				{
					Text: '第五十志愿',
					CollegesId: 0,
					CollegesCode: '',
					CollegesName: '',
					EnrollmentArea: '',
					CollegesType: 0,
					MajorList: []
				}
			],
			// 志愿表
			isPop: false,
			isCke: true,
			// 专业
			majorSel: false,
			majorTab: [],
			majorId: '',
			condition: {},
			page: 1,
			size: 10,
			totleNum: 0,
			TypeId1: 0,
			TypeId2: 0,
			TypeId3: 0,
			Year: '',
			obj: {}, // 当前选择学校
			key: ''
		};
	},
	// 加载
	created() {
		var that = this;
		that.key = Cookies.get('volunteer_key');
		var condition = Cookies.get('TBZYcondition');
		if (condition !== undefined) {
			that.condition = JSON.parse(condition);
			console.log(that.condition);
			that.VoluntarilySchool(1);
		}
	},

	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		VoluntarilySchool(page) {
			var that = this;
			var lock = that.$loading({ lock: true });
			that.isShow = false;
			var data = {
				page: page,
				size: 10,
				cityCode: that.condition.cityCode,
				candidatesType: that.condition.subject,
				score: parseInt(that.condition.branch),
				typeId: that.tabId
			};
			console.log(data);
			that.$api.HtppRequest(
				'SystemData/VoluntarilySchool',
				'POST',
				data,
				function(res) {
					lock.close();
					console.log('获取列表', res);

					if (res.flag && res.totle > 0) {
						var list = res.list;

						that.totleNum = res.totle;
						that.TypeId1 = res.TypeId1;
						that.TypeId2 = res.TypeId2;
						that.TypeId3 = res.TypeId3;
						if (page === 1) {
							that.list = [];
						}
						if (list.length > 0) {
							that.page = page;
							for (var i = 0; i < list.length; i++) {
								for (var k = 0; k < that.vltList.length; k++) {
									if (that.vltList[k].CollegesId === list[i].Id) {
										list[i].Voluntarily = k + 1;
									}
								}

								that.list.push(list[i]);
							}
						}

						console.log(that.list);
					}
				},
				function(err) {
					lock.close();
					console.log(err);
				}
			);
		},
		// 生成志愿表
		goVltD() {
			var that = this;
			var lock = that.$loading({ lock: true });
			if (!that.isCke) {
				return;
			}
			var isok = false;
			that.vltList.map(a => {
				if (a.CollegesId > 0) {
					isok = true;
				}
			});
			if (isok) {
				that.isCke = false;
				var VoluntarilyList = JSON.stringify(that.vltList);

				var data = {
					VoluntarilyList: VoluntarilyList,
					UserId: 0,
					CityCode: that.condition.cityCode,
					CityName: that.condition.cityName,
					Branch: that.condition.branch,
					Subject: that.condition.subject
				};
				console.log(data);
				that.$api.HtppRequest(
					'SystemData/AddVoluntarilySchool',
					'POST',
					data,
					function(res) {
						lock.close();
						console.log('返回', res);
						if (res.flag) {
							that.$api.reduceUserCount({ key: that.key });
							that.$router.push({ path: '/volunteerd', query: { tabeId: res.tabeId } });
						}
					},
					function(err) {
						lock.close();
						console.log(err);
					}
				);
			} else {
				lock.close();
				that.$util.showError('未选择志愿院校');
				return false;
			}
		},
		// 填报志愿
		goNextb() {
			this.$router.push('/volunteerb');
		},
		addschool() {
			this.majorBtn();
		},
		// 选择专业
		sleMj(xid) {
			var that = this;
			console.log(xid);

			var list = that.vltList[that.ZYixt].MajorList;
			list.push({
				Id: that.majorTab[xid].Id,
				Score: that.majorTab[xid].LowestScore,
				Name: that.majorTab[xid].MajorName
			});
			console.log('1111');
			that.vltList[that.ZYixt].MajorList = list;
			that.Current++;
			that.majorTab[xid].Number = that.Current;
			console.log(that.majorTab[xid].Number);
			console.log(list);
		},
		// 取消专业
		dleMj(xid) {
			var that = this;
			console.log(xid);
			var MajorList = that.vltList[that.ZYixt].MajorList;
			MajorList.splice(xid, 1);
			that.Current--;
			that.majorTab.map(dent => {
				if (dent.Number > that.majorTab[xid].Number) {
					dent.Number--;
				}
			});
			that.majorTab[xid].Number = 0;
			console.log(MajorList);
			that.vltList[that.ZYixt].MajorList = MajorList;
		},
		// 删除专业
		deltMajr(ixd, ixd2) {
			var that = this;
			var MajorList = that.vltList[ixd].MajorList;
			MajorList.splice(ixd2, 1);
			that.Current--;
			console.log(MajorList);
			that.vltList[ixd].MajorList = MajorList;
		},
		delMajorAll(ixd) {
			var that = this;
			that.vltList[ixd].MajorList = [];
		},
		// 选择自愿
		volunteerdSel(inxd) {
			var that = this;
			that.obj = that.list[inxd];
			console.log(that.obj);
			console.log(that.obj.Voluntarily);
			if (parseInt(that.obj.Voluntarily) > 0) {
				var ixt = parseInt(that.obj.Voluntarily) - 1;
				that.ZYixt = ixt;
				that.Year = that.obj.Year;

				// 判断院校是否选择，选择就清除

				for (var i = 0; i < that.vltList.length; i++) {
					if (that.vltList[i].CollegesId === that.obj.Id) {
						that.vltList[i].CollegesId = 0;
						that.vltList[i].CollegesCode = '';
						that.vltList[i].CollegesName = '';
						that.vltList[i].EnrollmentArea = '';
						that.vltList[i].CollegesType = 0;
						that.vltList[i].MajorList = [];
					}
				}

				that.vltList[ixt].CollegesId = that.obj.Id;
				that.vltList[ixt].CollegesCode = that.obj.CollegesCode;
				that.vltList[ixt].CollegesName = that.obj.CollegesName;
				that.vltList[ixt].EnrollmentArea = that.obj.EnrollmentArea;
				that.vltList[ixt].CollegesType = that.tabId;
				that.vltList[ixt].MajorList = [];
				that.Current = 0;
				that.getProfessionaScore(that.obj.CollegesName);

				// 获取学习专业列表
				that.majorPop();
			}
		},
		editMajor(CollegesName, ixt) {
			var that = this;
			that.ZYixt = ixt;
			that.obj = that.vltList[ixt];
			that.getProfessionaScore(CollegesName);
			// 获取学习专业列表
			that.majorPop();
			that.majorBtn();
		},
		// 获取院校专业
		getProfessionaScore(CollegesName) {
			var that = this;
			var lock = that.$loading({ lock: true });
			console.log(
				'SystemData/GetProfessionaScoreByColleges?cityCode=' +
					that.condition.cityCode +
					'&candidatesType=' +
					that.condition.subject +
					'&collegesName=' +
					CollegesName +
					'&year=' +
					that.Year
			);
			that.$api.HtppRequest(
				'SystemData/GetProfessionaScoreByColleges?cityCode=' +
					that.condition.cityCode +
					'&candidatesType=' +
					that.condition.subject +
					'&collegesName=' +
					CollegesName +
					'&year=' +
					that.Year,
				'GET',
				{},
				function(res) {
					console.log('获取专业列表', res);
					lock.close();
					if (res.flag) {
						that.majorTab = res.list;
						that.Current = 0;
						var list = that.vltList[that.ZYixt].MajorList;
						for (var i = 0; i < list.length; i++) {
							that.majorTab.map(imte => {
								if (list[i].Id === imte.Id) {
									imte.Number = i + 1;
									that.Current = imte.Number;
								}
							});
						}
					}
				},
				function(err) {
					lock.close();
					console.log(err);
				}
			);
		},
		// 选择专业弹窗
		majorPop() {
			this.majorSel = !this.majorSel;
		},
		// 志愿表弹窗
		majorBtn() {
			this.isPop = !this.isPop;
		},
		// 切换
		tabBtn(id) {
			this.tabId = id;
			this.VoluntarilySchool(1);
		},
		// 获取其他页
		GetPageList: function(val) {
			var that = this;
			that.VoluntarilySchool(val);
		}
	}
};
</script>

<style scoped>
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
.gkTest-step {
	padding: 40px;
}
/* volunteer-one */
.volunteer-one {
	width: 100%;
	height: auto;
	background-color: #f7f7f7;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 40px;
	margin-bottom: 40px;
}
.one-li {
	display: flex;
	align-items: center;
}
.one-li p {
	width: 100px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 15px;
	color: #fff;
	border-radius: 5px;
	background-color: #e7bb7c;
	margin: 0 20px;
}
.one-btn {
	display: flex;
	align-items: center;
}
.one-btn p {
	width: 120px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 15px;
	border-radius: 5px;
	cursor: pointer;
	margin: 0 20px;
}
.one-btn p:first-child {
	color: #333;
	background-color: #ccdde3;
}
.one-btn p:last-child {
	color: #fff;
	background-color: #333;
}
/* volunteer-list */
.volunteer-list {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.volunteer-tab {
	width: 100%;
	border-bottom: 2px solid #333;
	display: flex;
	align-items: center;
}
.volunteer-tab p {
	width: calc(100% / 3);
	height: 40px;
	line-height: 38px;
	border: 1px solid #333;
	border-radius: 5px 5px 0 0;
	text-align: center;
	font-size: 16px;
	color: #333;
	cursor: pointer;
}
.volunteer-tab .on-nav {
	background-color: #333;
	color: #fff;
}

/* major-list */
.major-list {
	width: 100%;
	height: auto;
	margin-top: 15px;
}
.major-list ul {
	width: 100%;
	height: auto;
}
.major-list ul li {
	border: 1px solid #eee;
	width: 100%;
	height: auto;
	padding: 20px 30px;
	margin-bottom: 20px;
	position: relative;
}
.major-li01 {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
}
.major-li-btn {
	width: 25%;
}
.major-li-btn p {
	width: 80%;
	height: 33px;
	line-height: 33px;
	text-align: center;
	background-color: #333;
	font-size: 16px;
	color: #fff;
	border-radius: 50px;
}
.major-li01-right {
	width: 75%;
	display: flex;
}
.major-li01-right p {
	width: 20%;
	display: flex;
	align-items: center;
	line-height: 33px;
}
.major-li01-right p span {
	font-size: 15px;
	color: #999;
}
.major-li01-right p span:nth-child(2) {
	color: #333;
}
.lastIndex .major-li01-right p .li-icon {
	width: 75px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	font-size: 15px;
	color: #ff3327;
	background-color: #fdc6c3;
	border-radius: 5px;
	margin-left: 20px;
}

.major-li02 {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.major-li02 p {
	font-size: 14px;
}
.major-txt01 {
	width: 75px;
	color: #999;
}
.major-txt02 {
	width: calc(100% - 120px);
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.major-more {
	width: 45px;
	color: #333;
	text-align: right;
	cursor: pointer;
}
.major-txt04 {
	color: #333;
}
.major-more-con {
	position: absolute;
	width: 98%;
	height: auto;
	background: rgba(0, 0, 0, 0.7);
	padding: 20px;
	font-size: 15px;
	color: #fff;
	left: 1%;
	bottom: 0;
	border-radius: 5px;
	margin-bottom: -14px;
	z-index: 1;
}
.major-more-con::after {
	position: absolute;
	content: '';
	right: 0;
	top: 0;
	width: 0;
	height: 0;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 14px solid rgba(0, 0, 0, 0.7);
	margin-top: -14px;
	margin-right: 24px;
}
.major-page {
	margin-bottom: 30px;
}

.widthx {
	margin-top: 20px;
	margin-bottom: 10px;
}

.widthx .major-li01-right {
	width: 100%;
}

.widthx .major-li01-right p:first-child {
	min-width: 22.2%;
}

.widthx .major-li01-right p:nth-child(2) {
	width: 32.3%;
}

.lastIndex .major-li01-right p {
	width: 35%;
}
/* volunteer-frome */
.volunteer-frome {
	width: 100%;
	height: auto;
}
.from-img {
	width: 80px;
	height: 230px;
	position: fixed;
	right: 0;
	top: 50%;
	margin-top: -115px;
	cursor: pointer;
}
.from-img img {
	width: 100%;
	height: 100%;
	display: block;
}
.from-pop {
	width: 600px;
	height: 700px;
	background-color: #fff;
	box-shadow: 0 0 15px #ccc;
	position: fixed;
	right: 80px;
	top: 50%;
	margin-top: -450px;
	z-index: 100;
	border: 1px solid #eee;
	overflow: hidden;
}
.from-tit {
	width: 100%;
	height: 40px;
	position: relative;
	background-color: #eaeaea;
}
.from-tit span {
	font-size: 16px;
	color: #333;
	width: 100%;
	height: 40px;
	line-height: 40px;
	text-align: center;
	display: block;
}
.from-tit img {
	width: 20px;
	height: 20px;
	display: block;
	position: absolute;
	right: 0;
	top: 0;
	margin-right: 20px;
	margin-top: 10px;
	cursor: pointer;
}
/* from-pList */
.from-pList {
	width: 100%;
	padding: 20px;
	height: calc(100% - 60px);
	overflow: auto;
}
.from-pList::-webkit-scrollbar {
	width: 2px;
	height: 2px;
}
/*滚动条里面小方块样式*/
.from-pList::-webkit-scrollbar-thumb {
	border-radius: 100px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: #333;
}
/*滚动条里面轨道样式*/
.from-pList::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 0;
	background: rgba(0, 0, 0, 0.1);
}
.plist-ul {
	width: 100%;
	height: auto;
	overflow: hidden;
	border-bottom: 1px solid #eee;
	margin-bottom: 20px;
	padding-bottom: 20px;
}
.ul-title {
	width: 100%;
	display: flex;
	align-items: center;
}
.ul-tleft {
	width: 100px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background-color: #333;
	border-radius: 4px;
	font-size: 15px;
	color: #fff;
	margin-right: 20px;
}
.ul-tright {
	width: calc(100% - 120px);
	height: auto;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.ul-right-c01 {
	display: flex;
	align-items: center;
}
.ul-right-c01 p {
	font-size: 14px;
	color: #333;
	padding: 0 10px;
}
.ul-right-c01 span {
	width: 75px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background-color: #fdc6c3;
	font-size: 14px;
	color: #ff3327;
	display: block;
	border-radius: 4px;
	margin-left: 10px;
}
.ul-right-btn {
	font-size: 15px;
	color: #333;
	cursor: pointer;
}
.list-li {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	height: auto;
	margin-top: 10px;
}
.list-li li {
	padding: 0 10px;
	width: 30%;
	height: 30px;
	background-color: #f7f7f7;
	margin-right: 25px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;
}
.list-li li:nth-child(3n + 3) {
	margin-right: 0px;
}
.list-li li span {
	font-size: 14px;
	color: #333;
	height: 30px;
	line-height: 30px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: calc(100% - 20px);
	display: block;
}
.list-li li img {
	width: 20px;
	height: 20px;
	display: block;
	cursor: pointer;
}
.add-school {
	width: calc(100% - 120px);
	display: flex;
	align-items: center;
	cursor: pointer;
}
.add-school img {
	width: 20px;
	height: 20px;
	display: block;
	margin-right: 10px;
}
.add-school p {
	font-size: 14px;
	color: #999;
}
/* major-pop */
.major-pop {
	width: 800px;
	height: 600px;
	position: fixed;
	z-index: 11;
	background-color: #fff;
	top: 50%;
	left: 50%;
	margin-top: -300px;
	margin-left: -400px;
	overflow: hidden;
}
.major-ptit {
	display: flex;
	width: 100%;
	position: relative;
	padding: 20px 0;
}
.major-ptit img {
	width: 20px;
	height: 20px;
	display: block;
	position: absolute;
	right: 20px;
	cursor: pointer;
}
.major-ptit p {
	font-size: 16px;
	color: #333;
	font-weight: bold;
	width: 100%;
	text-align: center;
}
.major-ptable {
	width: 100%;
	height: calc(100% - 80px);
	overflow: auto;
	padding: 0 20px;
}
.major-ptable::-webkit-scrollbar {
	width: 2px;
	height: 2px;
}
/*滚动条里面小方块样式*/
.major-ptable::-webkit-scrollbar-thumb {
	border-radius: 100px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: #333;
}
/*滚动条里面轨道样式*/
.major-ptable::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 0;
	background: rgba(0, 0, 0, 0.1);
}
.major-tab {
	width: 100%;
	height: auto;
	overflow: hidden;
	border: 1px solid #eee;
}
.major-tab tr {
	border-bottom: 1px solid #eee;
}
.major-tab tr th {
	width: calc(100% / 3);
	text-align: center;
	font-size: 15px;
	color: #333;
	background-color: #eaeaea;
	height: 50px;
}
.major-tab tr td {
	border-right: 1px solid #eee;
	font-size: 14px;
	color: #333;
	text-align: center;
	height: 50px;
}
.major-tab tr td span {
	width: 120px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	border-radius: 5px;
	background-color: #333;
	color: #fff;
	border: 1px solid #333;
	display: block;
	margin: 0 auto;
	cursor: pointer;
}
.major-tab tr td .on-span {
	background-color: #fff;
	color: #333;
}
</style>
